import { ActionTypes } from "../constants/action-types"

const initialState = {
    updateTutorialCategory:[]

}

export const UpdateTutorialCategoryReducer = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.EDIT_TUTORIAL_CATEGORY: 
    return {...state, updateTutorialCategory: payload}
    default: return state
}

}